import { createAsyncThunk } from '@reduxjs/toolkit';
import { ResponseErrorWithHandled, ResponseSuccess } from '../../shared/types';

import {
  DeleteRevokeInframailIpsRequest,
  GetInframailIpsRequest,
} from './types';

import {
  deleteRevokeInframailIps,
  getInframailIps,
  getInframailIpsDomains,
} from './helpers/inframail-ips.api';

export const getInframailIpsRequest = createAsyncThunk<
  ResponseSuccess,
  GetInframailIpsRequest,
  { rejectValue: ResponseErrorWithHandled }
>('domains/getInframailIpsRequest', async (payload, thunkAPI) => {
  try {
    return await getInframailIps(payload);
  } catch (e) {
    return thunkAPI.rejectWithValue(e as ResponseErrorWithHandled);
  }
});

export const getInframailIpsDomainsRequest = createAsyncThunk<
  ResponseSuccess,
  string,
  { rejectValue: ResponseErrorWithHandled }
>('domains/getInframailIpsDomainsRequest', async (payload, thunkAPI) => {
  try {
    return await getInframailIpsDomains(payload);
  } catch (e) {
    return thunkAPI.rejectWithValue(e as ResponseErrorWithHandled);
  }
});

export const deleteRevokeInframailIpsRequest = createAsyncThunk<
  ResponseSuccess,
  DeleteRevokeInframailIpsRequest,
  { rejectValue: ResponseErrorWithHandled }
>('domains/deleteRevokeInframailIpsRequest', async (payload, thunkAPI) => {
  try {
    return await deleteRevokeInframailIps(payload);
  } catch (e) {
    return thunkAPI.rejectWithValue(e as ResponseErrorWithHandled);
  }
});
